import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as NegotiationActions from '../../actions/HomeActions';
import { Footer, Header, LinkList } from '../../components';
import './style.scss';

class CommercialPlanList extends Component {
  componentDidMount = () => {
    this.props.getStations();
  };

  redirectToRede = () => {
    this.props.redirectToRede();
  };

  handleChangeType = (type) => {
    this.props.clearSearch();
    this.props.updateCommercialPlanType(type);
  }

  changeShowControlPlan = () => {
    this.props.clearSearch();
    if (this.props.commercialPlanType === 'Net')
      this.props.getPlans();
    else
      this.props.getPlansStations(this.props.selectedStation);
  }

  changeShowControlProjects = () => {
    this.props.clearSearch();
    if (this.props.commercialPlanType === 'Net')
      this.props.getProjects();
    else
      this.props.getProjectsStations(this.props.selectedStation);
  }

  updateSelectedStation = (event) => {
    const station = this.props.stations.find(s => s._id === event.target.value);
    this.props.updateSelectedStation(station || {}, this.props.search);
  }

  handleChangeSearch = (search) => {
    if (this.props.showControllPlan)
      this.props.searchPlan(search);

    if (this.props.showControllProjects)
      this.props.searchProject(search);
  }

  render = () => (
    <div className="commercial-plan">
      <Header showBackButton={true} />
      <LinkList commercialPlan={true} />
      <div className="container">
        <div className="row" />
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
          <span className="text text-plan-title">Planos Comerciais</span>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 box-options">
          <div className={`col-lg-1 col-md-1 col-sm-1 col-xs-1 form-group option vertical-centralized`}>
            <div className="pretty p-svg p-curve p-bigger">
              <input
                type="checkbox"
                name="comprehensiveness"
                checked={this.props.commercialPlanType === 'Net'}
                onChange={e =>
                  this.handleChangeType('Net')
                }
              />
              <div className="state p-success">
                <svg className="svg svg-icon" viewBox="0 0 20 20">
                  <path
                    className="check"
                    d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                  />
                </svg>
                <label className="text txt-option">Net</label>
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 form-group option vertical-centralized padding-select">
            <div className="pretty p-svg p-curve p-bigger">
              <input
                type="checkbox"
                name="comprehensiveness"
                checked={this.props.commercialPlanType === 'Pracas'}
                onChange={e =>
                  this.handleChangeType('Pracas')
                }
              />
              <div className="state p-success">
                <svg className="svg svg-icon" viewBox="0 0 20 20">
                  <path
                    className="check"
                    d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                  />
                </svg>
                <label className="text txt-option">Praças</label>
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div>
          <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
            {this.props.commercialPlanType === 'Net' && (
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right filter-box">
                <input
                  type="text"
                  placeholder="Nome do programa"
                  className="form-control input-search placeholder-custom"
                  onChange={e => this.handleChangeSearch(e.target.value)}
                  value={this.props.search}
                />
                <i className="fas fa-filter icon-filter" />
              </div>
            )}
            {this.props.commercialPlanType === 'Pracas' && (
              <div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right filter-box">
                  <select
                    className="form-control input-search placeholder-custom"
                    onChange={e => this.updateSelectedStation(e)}
                    value={this.props.selectedStation._id}
                    name="station"
                  >
                    <option value="">Selecione a praça</option>
                    {this.props.stations.map(s => (
                      <option value={s._id} key={s._id}>{s.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right filter-box">
                  <input
                    type="text"
                    placeholder="Nome do programa"
                    className="form-control input-search placeholder-custom"
                    onChange={e => this.handleChangeSearch(e.target.value)}
                    value={this.props.search}
                  />
                  <i className="fas fa-filter icon-filter" />
                </div>
              </div>
            )}
          </div>
        </div>
        {(this.props.commercialPlanType === 'Net' || this.props.selectedStation._id) && (
          <div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding comercial-plan">
              <span className="text clicked" onClick={this.changeShowControlPlan}>
                <i className={`fas ${this.props.showControllPlan ? 'fa-minus-circle' : 'fa-plus-circle' }  option-icon`}></i> Planos Comerciais de Linha
              </span>
            </div>
            {this.props.showControllPlan && (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text"></th>
                      <th className="text"></th>
                      <th className="text"></th>
                      <th className="text">PDF</th>
                      <th className="text">Excel</th>
                      <th className="text">PPT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.plans.map((p, i) => (
                      <tr key={i}>
                        <td><img src={p.url_image_destaque} height="80" width="150" /></td>
                        <td className="td-padding-more">{p.title}</td>
                        <td className="td-padding-more">
                          <div className={`circle ${!p.sunday ? 'none-day' : ''}`}><span>D</span></div>
                          <div className={`circle ${!p.monday ? 'none-day' : ''}`}><span>S</span></div>
                          <div className={`circle ${!p.tuesday ? 'none-day' : ''}`}><span>T</span></div>
                          <div className={`circle ${!p.wednesday ? 'none-day' : ''}`}><span>Q</span></div>
                          <div className={`circle ${!p.thursday ? 'none-day' : ''}`}><span>Q</span></div>
                          <div className={`circle ${!p.friday ? 'none-day' : ''}`}><span>S</span></div>
                          <div className={`circle ${!p.saturday ? 'none-day' : ''}`}><span>S</span></div>
                        </td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_comercialPlain} target="_blank">
                            <img
                              src="/img/icons/pdf.png"
                              className="download-icon"
                            />
                          </a>
                        </td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_excel} target="_blank">
                            <img
                              src="/img/icons/excel.png"
                              className="download-icon"
                            />
                          </a>
                        </td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_ppt} target="_blank">
                            <img
                              src="/img/icons/ppt.png"
                              className="download-icon ppt-icon"
                            />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding special-project">
              <span className="text clicked" onClick={this.changeShowControlProjects}>
                <i className={`fas ${this.props.showControllProjects ? 'fa-minus-circle' : 'fa-plus-circle' }  option-icon`}></i> Projetos Especiais
              </span>
            </div>
            {(this.props.showControllProjects && (this.props.selectedStation || this.props.commercialPlanType === 'Net')) && (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text"></th>
                      <th className="text"></th>
                      <th className="text">PDF</th>
                      <th className="text">Excel</th>
                      <th className="text">PPT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.projects.map((p, i) => (
                      <tr key={i}>
                       <td><img src={p.url_image_destaque} height="80" width="150" /></td>
                        <td className="td-padding-more">{p.title}</td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_comercialPlain} target="_blank">
                            <img
                              src="/img/icons/pdf.png"
                              className="download-icon"
                            />
                          </a>
                        </td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_excel} target="_blank">
                            <img
                              src="/img/icons/excel.png"
                              className="download-icon"
                            />
                          </a>
                        </td>
                        <td title="Download" className="td-download td-padding">
                          <a href={p.url_file_ppt} target="_blank">
                            <img
                              src="/img/icons/ppt.png"
                              className="download-icon ppt-icon"
                            />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = ({ homeReducer }) => {
  return {
    ...homeReducer
  };
};

export default connect(
  mapStateToProps,
  { ...NegotiationActions }
)(CommercialPlanList);
